import React from 'react';
import useStrapi from '../../hooks/useStrapi';
import { getStrapiMedia } from '../../utils/api';

const Clients = () => {
    const { data: partners } = useStrapi('/partnerss', { populate: '*' });

    if (!partners || partners.length === 0) {
        return null;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="content ms-5 ps-5">
                        <h2 className="title reveal-text">Partners</h2>
                    </div>
                    <div className="marquee">
                        <ul className="list-unstyled">
                            {partners.map((partner) => {
                                const imageUrl = getStrapiMedia(partner.Logo);
                                if (!imageUrl) return null;
                                return (
                                    <li key={partner.documentId || partner.id} className="item">
                                        <a href="/about" className="marquee-item rounded">
                                            <div className="marquee-content">
                                                <img src={imageUrl} alt={partner.Label || 'Partner Logo'} />
                                            </div>
                                        </a>
                                    </li>
                                );
                            })}
                            {/* Duplicate items for seamless marquee effect */}
                            {partners.map((partner) => {
                                const imageUrl = getStrapiMedia(partner.Logo);
                                if (!imageUrl) return null;
                                return (
                                    <li key={`duplicate-${partner.documentId || partner.id}`} className="item">
                                        <a href="/about" className="marquee-item rounded">
                                            <div className="marquee-content">
                                                <img src={imageUrl} alt={partner.Label || 'Partner Logo'} />
                                            </div>
                                        </a>
                                    </li>
                                );
                            })}
                            {/* Duplicate items for seamless marquee effect */}
                            {partners.map((partner) => {
                                const imageUrl = getStrapiMedia(partner.Logo);
                                if (!imageUrl) return null;
                                return (
                                    <li key={`duplicate-${partner.documentId || partner.id}`} className="item">
                                        <a href="/about" className="marquee-item rounded">
                                            <div className="marquee-content">
                                                <img src={imageUrl} alt={partner.Label || 'Partner Logo'} />
                                            </div>
                                        </a>
                                    </li>
                                );
                            })}
                            {/* Duplicate items for seamless marquee effect */}
                            {partners.map((partner) => {
                                const imageUrl = getStrapiMedia(partner.Logo);
                                if (!imageUrl) return null;
                                return (
                                    <li key={`duplicate-${partner.documentId || partner.id}`} className="item">
                                        <a href="/about" className="marquee-item rounded">
                                            <div className="marquee-content">
                                                <img src={imageUrl} alt={partner.Label || 'Partner Logo'} />
                                            </div>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Clients;
